import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {EvidVidsModule} from '@catmodules/models/evid-vids/evid-vids.module';
import {EvidModule} from '@catmodules/models/evid/evid.module';
import {FeatureEvidVidFormComponent} from '@catmodules/models/feature-evid-vid/components/feature-evid-vid-form/feature-evid-vid-form.component';
import {FeatureEvidVidWizardFormComponent} from '@catmodules/models/feature-evid-vid/components/feature-evid-vid-wizard-form/feature-evid-vid-wizard-form.component';
import {FeatureEvidVidService} from '@catmodules/models/feature-evid-vid/services/feature-evid-vid.service';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';

const publicComponents = [
  FeatureEvidVidFormComponent,
  FeatureEvidVidWizardFormComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  EvidModule,
  EvidVidsModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeatureEvidVidService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeatureEvidVidsModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-evid-vid/feature-evid-vid.module.ts